import { render, staticRenderFns } from "./CascoAjanlatAdatokB9_V0.vue?vue&type=template&id=ca051a74&"
import script from "./CascoAjanlatAdatokB9_V0.vue?vue&type=script&lang=js&"
export * from "./CascoAjanlatAdatokB9_V0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports